import merge from 'lodash/merge';

function serialize(obj) {
  const str = Object.keys(obj).reduce((accum, key) => {
    if (obj[key] != null) {
      accum.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
    }
    return accum;
  }, []);
  return `?${str.join('&')}`;
}

export default async (path, data = {}) => {
  const {
    errors = [],
    query,
    params,
    customContentType = false,
    ...dataToFetch
  } = data;

  let pathToServer = path;

  const token = sessionStorage.getItem('access_token')
    || localStorage.getItem('access_token')
    || sessionStorage.getItem('customer_access_token');

  merge(dataToFetch, { headers: { authorization: token } });

  if (['POST', 'PUT'].includes(dataToFetch.method) && !customContentType) {
    if (!('Content-Type' in dataToFetch)) {
      merge(dataToFetch, { headers: { 'Content-Type': 'application/json' } });
    }
  }

  if (params) {
    Object.keys(params).forEach((key) => {
      pathToServer = pathToServer.replace(`:${key}`, params[key]);
    });
  }

  if (query) pathToServer = `${pathToServer}${serialize(query)}`;

  const response = await fetch(`${pathToServer}`, dataToFetch);

  if (!response.ok) {
    let errorMessage = '';
    let payload = {};

    const error = errors.find(err => err.code === response.status);
    if (error) errorMessage = error.message;

    const contentType = response.headers.get('content-type');

    if (contentType.includes('application/json')) {
      payload = await response.json();
      if (!errorMessage) errorMessage = payload.message;
    }

    if (!errorMessage) errorMessage = 'Ocurrió un error al consultar el servidor';

    const errorObject = new Error(errorMessage);
    errorObject.body = payload;
    errorObject.status = response.status;

    throw errorObject;
  }

  return response;
};
